import React from "react";
var __jsx = React.createElement;
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import stl from "./AnyQustV2.module.css";
import { onPushDataLayer, onPushDataLayerNew } from "@/utils/events";
import { trackEvents } from "@/common/events/events";
import FaceBookAQSVG from "./anyQuestSvgs/FaceBookAQSVG";
import TwitterAQSVG from "./anyQuestSvgs/TwitterAQSVG";
import InstagramAQSVG from "./anyQuestSvgs/InstagramAQSVG";
import SnapchatAQSVG from "./anyQuestSvgs/SnapchatAQSVG";
import YoutubeQASVG from "./anyQuestSvgs/YoutubeQASVG";
import useWebView from "@hooks/useWebview";
import useContactNumbers from "@hooks/useContactNumbers";
var AnyQustV2 = function AnyQustV2(_ref) {
  var _ref$isContactUs = _ref.isContactUs,
    isContactUs = _ref$isContactUs === void 0 ? null : _ref$isContactUs,
    _ref$hasSocilaLinks = _ref.hasSocilaLinks,
    hasSocilaLinks = _ref$hasSocilaLinks === void 0 ? null : _ref$hasSocilaLinks;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var contactNumbers = useContactNumbers();
  var webview = useWebView();
  return /*#__PURE__*/React.createElement(React.Fragment, null, isContactUs && /*#__PURE__*/React.createElement("div", {
    className: [stl.mobileCallUs, "m-show"].join(" ")
  }, /*#__PURE__*/React.createElement("button", {
    className: ["blueBtn", "showWebView"].join(" "),
    onClick: function onClick() {
      webview.openUri("tel:".concat(contactNumbers.callCenterCallNumber));
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Call.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, t("اتصل", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("a", {
    className: ["blueBtn", "hideWebView"].join(" "),
    href: "tel:".concat(contactNumbers.callCenterCallNumber),
    onClick: function onClick() {
      onPushDataLayer("event", "communication", "contact_us", "call");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/Call.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, t("اتصل", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "greenBtn showWebView",
    onClick: function onClick() {
      webview.openUri("https://wa.me/".concat(contactNumbers.whatsappCallNumber));
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("واتساب", {
    ns: "web_home"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "greenBtn hideWebView",
    href: "https://wa.me/".concat(contactNumbers.whatsappCallNumber),
    rel: "noopener noreferrer",
    target: "_blank",
    onClick: function onClick() {
      // onlineContactEvent("online_contact", "Homepage", null);
      trackEvents("online_contact", {
        post_id: null,
        contact_type: "online_contact",
        contact_location: "Homepage"
      });
      onPushDataLayer("event", "communication", "contact_us", "whatsapp");
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/wpImg.svg",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("واتساب", {
    ns: "web_home"
  })))), /*#__PURE__*/React.createElement("div", {
    className: [stl.anyQustContainer, isContactUs ? "m-hide" : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.callHelpContainer
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "65px"
    },
    className: "icon-telephoneRed"
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  })), /*#__PURE__*/React.createElement("strong", null, t("عندك أي استفسار؟", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("p", null, t("نخدمك طيلة أيام الاسبوع خلال اوقات العمل التالية:", {
    ns: "web_home"
  }), /*#__PURE__*/React.createElement("br", null), t("من السبت حتى الخميس من الساعة 9 صباحاً حتى 11", {
    ns: "web_home"
  }), /*#__PURE__*/React.createElement("br", null), t("مساءً, الجمعة من 1 مساءً الى 11 مساءً", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("a", {
    className: [
      // this.props.isContactUs ? stl.isContactUs : undefined,
    ].join(" "),
    href: "tel:".concat(contactNumbers.callCenterCallNumber),
    onClick: function onClick() {
      // onlineContactEvent("call", "Homepage", null);
      trackEvents("online_contact", {
        post_id: null,
        contact_type: "call",
        contact_location: "Homepage"
      });
      onPushDataLayer("event", "communication", "contact_us", "call");
      onPushDataLayerNew("syarah_events", "contact", "CSRContact");
    }
  }, contactNumbers.callCenterDisplayNumber)), /*#__PURE__*/React.createElement("a", {
    href: "https://wa.me/".concat(contactNumbers.whatsappCallNumber),
    rel: "noopener noreferrer",
    target: "_blank",
    onClick: function onClick() {
      //onlineContactEvent("whatsapp", "Homepage", null);
      trackEvents("online_contact", {
        post_id: null,
        contact_type: "whatsapp",
        contact_location: "Homepage"
      });
      onPushDataLayer("event", "communication", "contact_us", "whatsapp");
      onPushDataLayerNew("syarah_events", "contact", "CSRContact");
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-wpImg",
    style: {
      fontSize: "24px"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "path1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path2"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path3"
  }), /*#__PURE__*/React.createElement("span", {
    className: "path4"
  })), /*#__PURE__*/React.createElement("span", null, t("تواصل عبر واتساب", {
    ns: "web_home"
  })))))), hasSocilaLinks && /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.contMaxWidth].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.socialLinks].join(" ")
  }, /*#__PURE__*/React.createElement("h2", null, " ", t("تابعنا لتصلك آخر عروض السيارات", {
    ns: "web_home"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: stl.actAsHref,
    onClick: function onClick() {
      trackEvents("online_contact", {
        post_id: post_id,
        contact_type: "whatsapp",
        contact_location: page
      });
      webview.openUri("https://www.facebook.com/syarah.KSA")["catch"](function () {
        return window.location.href = "https://www.facebook.com/syarah.KSA";
      });
    }
  }, /*#__PURE__*/React.createElement(FaceBookAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/Syarah_ksa"
  }, /*#__PURE__*/React.createElement(TwitterAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://www.instagram.com/Syarah_ksa/"
  }, /*#__PURE__*/React.createElement(InstagramAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://www.snapchat.com/add/syarah_ksa"
  }, /*#__PURE__*/React.createElement(SnapchatAQSVG, null)), /*#__PURE__*/React.createElement("a", {
    href: "https://www.youtube.com/channel/UCAceZ20JD3qef5OQSVc95Bw"
  }, /*#__PURE__*/React.createElement(YoutubeQASVG, null))))));
};
export default AnyQustV2;